export default __webpack_public_path__ + "static/media/consultancy.6d0ad90c.svg";